import React from 'react';

const LoginPage = () => {
    return (
        <div>
            login page
        </div>
    );
};

export default LoginPage;